export default "__VITE_ASSET__7c6ed3b6__"